import LegacyRouteRedirect from '@/components/navigation/LegacyRouteRedirect';
import { lazy } from 'react';
import { FuseRouteItemType } from '@fuse/utils/FuseUtils';

const EquipmentTypes = lazy(() => import('./EquipmentTypes'));
const EquipmentTypesCatalogueView = lazy(() => import('./components/views/EquipmentTypesCatalogueView'));
const EquipmentTypesListView = lazy(() => import('./components/views/EquipmentTypesListView'));
const EquipmentTypeFormView = lazy(() => import('./components/views/EquipmentTypeFormView'));

const EquipmentTypesRoute: FuseRouteItemType = {
	path: '/catalog',
	element: <EquipmentTypes />,
	children: [
		{ index: true, element: <LegacyRouteRedirect to="/catalog/equipment-types" /> },
		{
			path: 'equipment-types',
			element: <EquipmentTypesListView />
		},
		{
			path: 'order',
			element: <EquipmentTypesCatalogueView />
		},
		{
			path: 'equipment-types/new',
			element: <EquipmentTypeFormView />
		},
		{
			path: 'equipment-types/:id',
			element: <EquipmentTypeFormView />
		}
	]
};

export default EquipmentTypesRoute;
